import React, { Component } from 'react'
import { Modal } from "react-bootstrap";
import { Row, Col, Button, Container, Form } from "react-bootstrap";
import moment from "moment";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";

const CREATE_MATERIALS_STORE_DETAILS = gql`
        mutation($params:CreateMaterialStoreDetails) {
            createMaterialStoreDetails(params:$params)
        }
    `;

class MaterialstoreCreationModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            branch: "",
            branchError: "",
            exam: "",
            examError: "",
            class: "",
            classError: "",
            materialTypesData: props.getMaterialTypes,
            selectedMaterialType: "",
            materialtypesError: "",
            getExams: [],
            getClasses: [],
            getBranches: [],
            dataClear: 1,
            loadingSpinner: 0,
            submitted: false,
            defaultvalue: 0,
            currentStep: 1,
            submitError: "",
            is_grouping: true,
            date: new Date().toISOString().slice(0, 10),
            newly_Existing_StoreDetails: [],
            materialDetails: [],
            materialDataSpinner: 0
        };
    }

    addRow = () => {
        console.log("sssss");
        let array = this.state.newly_Existing_StoreDetails
        array.push({
            id: null, material_id: null, material_name: "", material_count: "", material_received_date: "", materialNameError: "",
            quantity_error: "",
            material_received_date_error: ""
        })
        this.setState({
            newly_Existing_StoreDetails: array
        })
    }

    handleInputChange = (e, i) => {
        const name = e.target.name;
        const value = e.target.value;
        console.log("nammamm", name, value);
        let getArray = [];
        if (name == "branch") {
            if (value != "0") {
                let uniqueExams = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == value).map((item1) => item1.exam_id))].sort();
                uniqueExams.map((val) => {
                    let individualExamData = this.props.globals.exams.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualExamData.id,
                        label: individualExamData.exam
                    }
                    getArray.push(newObj);
                })


                this.setState({
                    materialDataSpinner: 0,
                    branch: value,
                    branchError: "",
                    exam: "",
                    examError: "",
                    class: "",
                    classError: "",
                    materialtypesError: "",
                    getExams: getArray,
                    getClasses: [],
                    loadingSpinner: 0,
                    submitted: false,
                    submitError: "",
                    newly_Existing_StoreDetails: [],
                    materialDetails: [],

                })
                if (!this.state.is_grouping) {
                    this.getMaterials(value, "");
                    if (this.state.selectedMaterialType != "") {
                        this.getMaterialStoreDetails1(value, this.state.class, this.state.date);
                    }
                }
            } else {
                this.setState({
                    branch: "",
                    branchError: "",
                    exam: "",
                    examError: "",
                    class: "",
                    classError: "",
                    materialtypesError: "",
                    getExams: [],
                    getClasses: [],
                    loadingSpinner: 0,
                    submitted: false,
                    submitError: "",
                    newly_Existing_StoreDetails: [],
                    materialDetails: [],
                    materialDataSpinner: 0,
                })
            }
        }
        if (name == "exam") {
            if (value != "0") {
                let uniqueClasses = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branch && item.exam_id == value).map((item1) => item1.class_id))].sort();
                uniqueClasses.map((val) => {
                    let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualClassData.id,
                        label: individualClassData.class
                    }
                    getArray.push(newObj);
                })
                this.setState({

                    branchError: "",
                    exam: value,
                    examError: "",
                    class: "",
                    classError: "",
                    materialtypesError: "",
                    getClasses: getArray,
                    loadingSpinner: 0,
                    submitted: false,
                    submitError: "",
                    newly_Existing_StoreDetails: [],
                    materialDetails: [],
                    materialDataSpinner: 0,

                })
            } else {
                this.setState({
                    branchError: "",
                    exam: "",
                    examError: "",
                    class: "",
                    classError: "",
                    materialtypesError: "",
                    getClasses: [],
                    loadingSpinner: 0,
                    submitted: false,
                    submitError: "",
                    newly_Existing_StoreDetails: [],
                    materialDetails: [],
                    materialDataSpinner: 0,
                })
            }
        }
        if (name == "class") {
            if (value != "0") {
                this.setState({
                    branchError: "",
                    examError: "",
                    class: value,
                    classError: "",
                    materialtypesError: "",
                    loadingSpinner: 0,
                    submitted: false,
                    submitError: "",
                    newly_Existing_StoreDetails: [],
                    materialDetails: [],
                    materialDataSpinner: 0,
                })
                this.getMaterials(this.state.branch, value);
                this.getMaterialStoreDetails1(this.state.branch, value, this.state.date);
            } else {
                this.setState({
                    branchError: "",
                    examError: "",
                    class: "",
                    classError: "",
                    materialtypesError: "",
                    loadingSpinner: 0,
                    submitted: false,
                    submitError: "",
                    newly_Existing_StoreDetails: [],
                    materialDetails: [],
                    materialDataSpinner: 0,
                })
            }
        }
        if (name == "materialtypes") {
            if (value != "0") {
                let getBranches = this.props.globals.globalBranches;
                let grouping = this.state.materialTypesData.find((item) => item.id == value).is_grouping == 1 ? true : false
                this.setState({
                    branch: "",
                    branchError: "",
                    exam: "",
                    examError: "",
                    class: "",
                    classError: "",
                    selectedMaterialType: value,
                    materialtypesError: "",
                    getExams: [],
                    getClasses: [],
                    getBranches: getBranches,
                    loadingSpinner: 0,
                    submitted: false,
                    submitError: "",
                    is_grouping: grouping,
                    newly_Existing_StoreDetails: [],
                    materialDetails: [],
                    materialDataSpinner: 0,
                })
            } else {
                this.setState({
                    branch: "",
                    branchError: "",
                    exam: "",
                    examError: "",
                    class: "",
                    classError: "",
                    selectedMaterialType: "",
                    materialtypesError: "",
                    getExams: [],
                    getClasses: [],
                    getBranches: [],
                    loadingSpinner: 0,
                    submitted: false,
                    submitError: "",
                    is_grouping: true,
                    newly_Existing_StoreDetails: [],
                    materialDetails: [],
                    materialDataSpinner: 0,
                })

            }
        }
    }

    getMaterials = async (val1, val2) => {
        const result = await this.props.client.query({
            query: gql`
                    query($institute_id:Int,$branch_id:Int,$exam_id:Int,$class_id:Int,$material_type_id:Int){
                        getMaterials(institute_id:$institute_id,branch_id:$branch_id,exam_id:$exam_id,class_id:$class_id,material_type_id:$material_type_id){
                            id
                            material_name
                        }
                    }
                    `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(val1),
                exam_id: parseInt(this.state.exam),
                class_id: parseInt(val2),
                material_type_id: parseInt(this.state.selectedMaterialType)
            },
            fetchPolicy: 'network-only'
        })

        if (result.data.getMaterials.length > 0) {
            let data = result.data.getMaterials;
            this.setState({ materialDetails: data })
        }
    }

    getMaterialStoreDetails1 = async (branchValue, classValue, date) => {

        this.setState({ newly_Existing_StoreDetails: [], materialDataSpinner: 1 })

        const result1 = await this.props.client.query({

            query: gql`
                query($institute_id:Int,$branch_id:Int,$exam_id:Int,$class_id:Int,$material_type_id:Int,$date:String){
                    getMaterialStoreDetails(institute_id:$institute_id,branch_id:$branch_id,exam_id:$exam_id,class_id:$class_id,material_type_id:$material_type_id,date:$date){
                        quantity
                      }
                   }
                `,

            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(branchValue),
                exam_id: parseInt(this.state.exam),
                class_id: parseInt(classValue),
                material_type_id: parseInt(this.state.selectedMaterialType),
                date: moment(date).unix().toString(),
            },
            fetchPolicy: 'network-only'
        });



        console.log("result", result1);
        if (result1.data.getMaterialStoreDetails.length > 0) {
            let data = result1.data.getMaterialStoreDetails
            let materialData = [];
            data[0].quantity.map((item) => {
                materialData.push({
                    ...item, materialNameError: "",
                    quantity_error: "",
                    material_received_date_error: ""
                })
            })
            this.setState({ newly_Existing_StoreDetails: materialData, materialDataSpinner: 0 })
        } else {
            this.setState({
                newly_Existing_StoreDetails: [{
                    id: null,
                    material_id: "",
                    material_name: "",
                    material_count: "",
                    material_received_date: "",
                    materialNameError: "",
                    quantity_error: "",
                    material_received_date_error: ""
                }],
                materialDataSpinner: 0
            })
        }
    }



    handleSubmit = () => {

        if (this.state.selectedMaterialType == "" || this.state.selectedMaterialType == "--Select Material--") {
            this.setState({ materialtypesError: "Please Select Material" })
            return ""
        }

        if (this.state.branch == "" || this.state.branch == "--Select Branch--") {
            this.setState({ branchError: "Please Select Branch" })
            return ""
        }
        if (this.state.is_grouping && (this.state.exam == "" || this.state.exam == "--Select Exam--")) {
            this.setState({ examError: "Please Select Exam" })
            return ""
        }
        if (this.state.is_grouping && (this.state.class == "" || this.state.class == "--Select Class--")) {
            this.setState({ classError: "Please Select Class" })
            return ""
        }

        let stopExecuting = false;

        this.state.newly_Existing_StoreDetails.some((obj, i) => {
            let errorUpdate = this.state.newly_Existing_StoreDetails
            console.log("errorUpdate", errorUpdate);

            if (obj.material_name == "" || obj.material_name == undefined) {
                errorUpdate[i] = { ...obj, materialNameError: "Please Select Material Name" }
                this.setState({ newly_Existing_StoreDetails: errorUpdate })
                stopExecuting = true
                return true;
            }

            if (obj.material_count == "" || obj.material_count == undefined) {
                errorUpdate[i] = { ...obj, quantity_error: "Please Enter Quantity" }
                this.setState({ newly_Existing_StoreDetails: errorUpdate })
                stopExecuting = true
                return true;
            }

            if (obj.material_received_date == "" || obj.material_received_date == undefined) {
                errorUpdate[i] = { ...obj, material_received_date_error: "Please Select Received Date" }
                this.setState({ newly_Existing_StoreDetails: errorUpdate })
                stopExecuting = true
                return true;
            }
        })

        if (stopExecuting) {
            return ""
        }

        let array = []
        if (this.state.newly_Existing_StoreDetails.length > 0) {
            this.state.newly_Existing_StoreDetails.map((item) => {
                array.push({
                    id: item.id,
                    material_id: item.material_id,
                    material_name: item.material_name,
                    material_count: item.material_count,
                    material_received_date: item.material_received_date
                })
            })
        }

        const params = {
            institute_id: parseInt(Cookies.get("institutionid")),
            branch_id: parseInt(this.state.branch),
            exam_id: parseInt(this.state.exam),
            class_id: parseInt(this.state.class),
            material_type_id: parseInt(this.state.selectedMaterialType),
            quantity: array,
            received_by: parseInt(Cookies.get("id")),
            inserted_by: parseInt(Cookies.get("id")),
        }
        console.log("params", params)
        // return ""
        this.setState({
            loadingSpinner: 1
        });

        this.createMaterialStoreDetails(
            params
        ).catch(error => {
            console.log("catch if error");
            console.log(error);
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message), loadingSpinner: 0
            });
            console.error("ERR =>", error.graphQLErrors.map(x => x.message));
        });
    }

    createMaterialStoreDetails = async (
        params) => {
        await this.props.createMaterialStoreDetails({
            variables: {
                params,
            },
            update: (store, { data }) => {
                console.log("data.finishTest", data);
                if (data.createMaterialStoreDetails) {
                    this.setState({
                        loadingSpinner: 0,
                        currentStep: 5
                    })
                    setTimeout(() => {
                        this.props.onHide();
                        window.location.reload(false);
                    }, 1500);
                }
            }

        });
    };

    SetpageLoad = () => {
        this.setState({ currentStep: 1, submitError: "" });
        this.props.onHide();
    };

    componentDidUpdate() {
        if (this.props.show === true && this.state.dataClear == 0) {
            this.setState({
                branch: "",
                branchError: "",
                exam: "",
                examError: "",
                class: "",
                classError: "",
                materialTypesData: this.props.getMaterialTypes,
                selectedMaterialType: "",
                materialtypesError: "",
                getExams: [],
                getClasses: [],
                getBranches: [],
                dataClear: 1,
                loadingSpinner: 0,
                submitted: false,
                defaultvalue: 0,
                currentStep: 1,
                submitError: "",
                is_grouping: true,
                date: new Date().toISOString().slice(0, 10),
                newly_Existing_StoreDetails: [],
                materialDetails: [],
                materialDataSpinner: 0
            })
        }
        if (this.props.show === false && this.state.dataClear == 1) {
            this.setState({ dataClear: 0 })
        }
    }

    handleChange = (a, i) => {
        let name = a.target.name;
        let value = a.target.value;

        console.log("dddd", name, value);

        let array = [];

        this.state.newly_Existing_StoreDetails.map((item, index) => {
            if (i == index) {
                let material_id = item.material_id;
                let material_count = item.material_count;
                let material_received_date = item.material_received_date;
                let material_name = item.material_name

                if (name == "materialName") {

                    if (value != "") {
                        const filteredMaterials = this.state.materialDetails.filter((a) => a.id == value);
                        material_id = value;
                        material_name = filteredMaterials[0].material_name;
                        material_count = "";
                        material_received_date = "";

                    } else {
                        material_id = null;
                        material_name = "";
                        material_count = "";
                        material_received_date = "";;
                    }

                } else if (name == "quantity") {
                    material_count = value;
                } else {
                    if (value != "") {
                        const stimestamp = moment(value).unix();
                        material_received_date = stimestamp;
                    } else {
                        material_received_date = "";
                    }
                }
                array.push({ ...item, material_id, material_name, material_count, materialNameError: "", quantity_error: "", material_received_date_error: "", material_received_date })
            } else {
                array.push({ ...item })
            }
        })
        this.setState({ newly_Existing_StoreDetails: array })
    }



    selectDate = (e) => {
        const selectedDate = e.target.value;
        this.setState({ date: selectedDate, newly_Existing_StoreDetails: [] });
        if (this.state.branch != "" && this.state.is_grouping && this.state.exam != "" && this.state.class != "") {
            this.getMaterialStoreDetails1(this.state.branch, this.state.class, selectedDate);
        } else if (this.state.branch != "" && !this.state.is_grouping) {
            this.getMaterialStoreDetails1(this.state.branch, this.state.class, selectedDate);
        }
    }

    render() {


        console.log("gggggggggggg", this.state);

        return (

            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="example-modal-sizes-title-lg"
            >
                    <Modal.Header closeButton>
                        <Modal.Title>Material Details Update</Modal.Title>
                    </Modal.Header>
                    <Container>
                        <Modal.Body className="p-3">
                            <Row>
                                <Col xl={12} lg={12} md={12} sm={12} className="mt-3">
                                    <Form>
                                        <Form.Row>
                                            <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectMaterial">
                                                <h6>Material Type</h6>
                                                <Form.Control as="select" name="materialtypes" onChange={this.handleInputChange} value={this.state.materialtypes} isInvalid={this.state.materialtypesError}>
                                                    <option value={this.state.defaultvalue}>--Select Material--</option>
                                                    {this.state.materialTypesData.map(item1 => (
                                                        <option key={item1.id} value={item1.id}>
                                                            {item1.material_type}
                                                        </option>
                                                    ))
                                                    }
                                                </Form.Control>
                                                <Form.Text className="form-text text-danger" type="invalid">
                                                    {this.state.materialtypesError}
                                                </Form.Text>
                                            </Form.Group>

                                            <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectBranch">
                                                <h6>Branch</h6>
                                                <Form.Control as="select" name="branch" onChange={this.handleInputChange} value={this.state.branch} isInvalid={this.state.branchError}>
                                                    <option value={this.state.defaultvalue}>--Select Branch--</option>
                                                    {this.state.getBranches.map(branchdata => (
                                                        <option key={branchdata.id} value={branchdata.id}>
                                                            {branchdata.branch_name}
                                                        </option>
                                                    ))}
                                                </Form.Control>
                                                <Form.Text className="form-text text-danger" type="invalid">
                                                    {this.state.branchError}
                                                </Form.Text>
                                            </Form.Group>

                                            {
                                                this.state.is_grouping ? (
                                                    <>
                                                        <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectExam">
                                                            <h6>Exam</h6>
                                                            <Form.Control as="select" name="exam" onChange={this.handleInputChange} value={this.state.exam} isInvalid={this.state.examError}>
                                                                <option value={this.state.defaultvalue}>--Select Exam--</option>
                                                                {this.state.getExams.map(item => (
                                                                    <option key={item.value} value={item.value}>
                                                                        {item.label}
                                                                    </option>
                                                                ))}
                                                            </Form.Control>
                                                            <Form.Text className="form-text text-danger" type="invalid">
                                                                {this.state.examError}
                                                            </Form.Text>
                                                        </Form.Group>
                                                        <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectClass">
                                                            <h6>Class</h6>
                                                            <Form.Control as="select" name="class" onChange={this.handleInputChange} value={this.state.class} isInvalid={this.state.classError}>
                                                                <option value={this.state.defaultvalue}>--Select Class--</option>
                                                                {this.state.getClasses.map(classdata => (
                                                                    <option key={classdata.value} value={classdata.value}>
                                                                        {classdata.label}
                                                                    </option>
                                                                ))}
                                                            </Form.Control>
                                                            <Form.Text className="form-text text-danger " type="invalid">
                                                                {this.state.classError}
                                                            </Form.Text>
                                                        </Form.Group>
                                                    </>
                                                ) : ("")
                                            }

                                            <Form.Group as={Col} lg={3} md={12} sm={12}>
                                                <h6>Select Date</h6>
                                                <div className="filter-block d-flex align-items-center mr-4">
                                                    <input type="date" name="date" className='form-control' value={this.state.date} onChange={(e) => this.selectDate(e)} />
                                                </div>
                                            </Form.Group>
                                        </Form.Row>
                                    </Form>
                                </Col>
                            </Row>

                            <Row>
                                {
                                    this.state.newly_Existing_StoreDetails.length > 0 ? (
                                        <Row>
                                            {
                                                this.state.newly_Existing_StoreDetails.map((item, index) => (
                                                    <>
                                                        <Col sm={4} >
                                                            <Form.Group controlId="SelectClass" style={{ marginLeft: "13px" }}>
                                                                <h6>Material Name</h6>
                                                                <Form.Control as="select" value={item.material_id}
                                                                    onChange={(e) => this.handleChange(e, index)} name="materialName">
                                                                    <option value="">--Material Details--</option>
                                                                    {this.state.materialDetails.map((item, index) => (
                                                                        <option key={item.id} value={item.id}>{item.material_name}</option>
                                                                    ))}
                                                                </Form.Control>
                                                                <Form.Text className="form-text text-danger" type="invalid">
                                                                    <span className="text-danger">{item.materialNameError}</span>
                                                                </Form.Text>
                                                            </Form.Group>
                                                        </Col>

                                                        <Col sm={4}>
                                                            <h6>Enter Quantity</h6>
                                                            <input type='number' value={item.material_count} onChange={(e) => this.handleChange(e, index)} name='quantity' className="form-control" placeholder='Enter Quantity' />
                                                            <Form.Text className="form-text text-danger" type="invalid">
                                                                <span className="text-danger">{item.quantity_error}</span>
                                                            </Form.Text>

                                                        </Col>

                                                        <Col sm={4}>
                                                            <h6>Received Date</h6>
                                                            <input type='datetime-local' name='material_received_date' className='form-control' Value={item.material_received_date != "" ? moment.unix(item.material_received_date).format('YYYY-MM-DD HH:mm') : NaN} onChange={(e) => this.handleChange(e, index)} />
                                                            <Form.Text className="form-text text-danger" type="invalid">
                                                                <span className="text-danger">{item.material_received_date_error}</span>
                                                            </Form.Text>

                                                        </Col>

                                                    </>
                                                ))
                                            }
                                        </Row>
                                    ) : ("")
                                }
                            </Row>

                            {

                                this.state.materialDataSpinner == 1 ? (
                                    <Row className="my-2">
                                        <Col>
                                            <div class="spinner-border  text-center loading-img-center"></div>
                                        </Col>
                                    </Row>
                                ) : ("")
                            }

                            {
                                this.state.newly_Existing_StoreDetails.length > 0 ? (
                                    <div>
                                        <Button onClick={this.addRow} style={{ backgroundColor: "#213046", color: "#ffffff" }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-plus" viewBox="0 0 16 16">
                                                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                            </svg>
                                        </Button>
                                    </div>
                                ) : ("")
                            }

                        </Modal.Body>
                    </Container>
                    <Modal.Footer variant="white" >
                        <Row>
                            <Col sm={12}>
                                {this.state.currentStep == 5 ? (
                                    <Form.Text className="form-text text-success mb-2 " style={{ textAlign: "center" }}>
                                        Creation Successfully
                                    </Form.Text>
                                ) : (
                                    <Form.Text className="form-text text-danger mb-2" style={{ textAlign: "center" }}>
                                        {this.state.submitError}
                                    </Form.Text>
                                )}
                            </Col>
                        </Row>
                        {
                            this.state.newly_Existing_StoreDetails.length > 0 ? (
                                <Row>
                                    <Col sm={12} style={{ display: "block", textAlign: "center" }}>
                                        <Button className="text-uppercase" style={{ backgroundColor: "#213046", color: "#ffffff" }} onClick={(e) => this.handleSubmit()}>
                                            {
                                                this.state.loadingSpinner == 1 ? (
                                                    <span className="spinner-border spinner-border-sm"></span>
                                                ) : ""
                                            }
                                            Create</Button>
                                    </Col>
                                </Row>
                            ) : ("")
                        }

                    </Modal.Footer>
            </Modal>
        )
    }
}
export default withRouter(withApollo(compose(
    graphql(CREATE_MATERIALS_STORE_DETAILS, {
        name: "createMaterialStoreDetails"
    }),
)(MaterialstoreCreationModal)));
